import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import '../css/social-hint.css';

export default class SocialHint extends React.PureComponent {
    state = {
        translations: null,
        hints: null,
    };

    componentDidMount() {
        this.getTranslations();
    }

    getTranslations = () => {
        fetch('/admin_api/social_translate/?limit=9999')
            .then((response) => response.json())
            .then((response) => {
                this.setState({
                    translations: response.results,
                }, this.getHints);
            });
    };

    getHints = () => {
        const { textareaSelector } = this.props;
        const { translations } = this.state;

        const textarea = document.querySelector(textareaSelector);

        if (!textarea) {
            return false;
        }

        const match = textarea.value.match(/\[twitter(.|\n)*?\[\/twitter\]/gm);

        if (!match || !match.length) {
            return false;
        }

        const ids = match.reduce((accumulator, tag) => {
            const matched = tag.match(/\d{10,}/g);

            if (Array.isArray(matched) && matched.length > 0) {
                return [...accumulator, matched[0]];
            }

            return accumulator;
        }, []);

        const hints = ids.reduce((result, id) => {
            const temp = [...result];
            const newItem = translations.find((translation) => translation.message_id === id);

            if (newItem) {
                temp.push(newItem);
            }

            return temp;
        }, []);

        this.setState({
            hints,
        });
    };

    render() {
        const { hints } = this.state;

        if (!hints || !hints.length) {
            return null;
        }

        return (
            <div className="social-hint">
                <FontAwesomeIcon icon={['fab', 'twitter']} />
                <div className="social-hint__popup">
                    {hints.map((hint) => hint && (
                        <>
                            <p key={`title-${hint.id}`} className="social-hint__title">{hint.message_id}</p>
                            <p key={`translation-${hint.id}`} className="social-hint__translation">{hint.text}</p>
                        </>
                    ))}
                </div>
            </div>
        );
    }
}
